module.exports = __webpack_public_path__ + "img/icon-verified black.dea7cfe1.svg";